<style>
.constructor_position {
    position: absolute;
    border: 1px solid black;
    box-sizing: border-box;
    background-color: #FFFFFF;
}
.constructor_position.tri_top, .constructor_position.tri {
    background-color: white;
    border: 0;
}
.plus{
    height: 100%;
    background-position: center;
    position: absolute;
    max-width: 100%;
}
.plus .plus_click{
    height: 100%;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 20px;
    max-height: 20px;
    min-width: 17px;
    min-height: 17px;
    cursor: pointer;
}
.item {
    height: 100%;
    background-position: center;
    cursor: pointer;
    position: absolute;
    max-width: 100%;
    background-color: #fff;
    border: 1px solid black;
    box-sizing: border-box;
    /*z-index: 9990;*/
    background-size: 32px;
    border-radius: 5px;
}
.middle .item {
    background-size: 20px;
}
.item_hidden{
    height: 100%;
    background-position: center;
    cursor: pointer;
    position: absolute;
    max-width: 100%;
    background-color: #ffffff00;
    /*border: 1px solid black;*/
    box-sizing: border-box;
    opacity: 1;
    z-index: 9999;
}
.plus .plus_click:hover:after, .plus.active .plus_click:after{
    background-image: url('./images/red-plus.png');
    background-position: center;
}
.plus .plus_click:after{
    content: "";
    display: block;
    background: url('./images/plus.png') no-repeat;
    /*height: 100%;*/
    background-position: center;
    cursor: pointer;
    position: absolute;
    max-width: 100%;
    /*width: 100%;*/
    z-index: 9999;
    background-size: 32px;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    border: 1px solid #000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
}

.plus:hover, .plus.active  {
    /*box-shadow: 0px 0px 0px 2px red inset;*/
    border: unset;
}

.middle .plus .plus_click:after{
    background-size: 11px;
}
.middle .plus .plus_click:hover:after, .middle .plus.active .plus_click:after{
    background-size: 11px;
}
.dragover {
    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(0, 255, 20, 0.1);
    z-index: 9999999;
}

.exceptionElement {
    position: absolute;
    height: 100%;
    background-color: rgba(255, 0, 0, 0.2);
    z-index: 99999999;
}
.constructor_top_side {
    position: absolute;
    width: 100%;
    height: 100%;
}
.constructor_top_side .plus .plus_click:after {
    content: "";
    background-image: url(./images/plus.png);
    background-position: center;
    background-repeat: no-repeat;
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    border: 1px solid #000;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 100000;
    background-color: white;
}
.middle .constructor_top_side .plus .plus_click:after {
    width: 15px;
    height: 15px;
}
.constructor_top_side .plus .plus_click:hover:after, .constructor_top_side .plus.active .plus_click:after{
    background-image: url(./images/red-plus.png);
}
/*.plus_hint:hover::before {*/
    /*content: "Нижний ярус";*/
    /*position: absolute;*/
    /*width: 110px;*/
    /*height: 28px;*/
    /*background: #000000ad;*/
    /*border-radius: 5px;*/
    /*color: #fff;*/
    /*text-align: center;*/
    /*vertical-align: middle;*/
    /*font-size: 16px;*/
    /*padding-top: 7px;*/
    /*top: -30px;*/
    /*left: 38%;*/
    /*z-index: 9999999;*/
/*}*/
/*.top_plus_hint:hover::before {*/
    /*content: "Верхний ярус";*/
    /*position: absolute;*/
    /*width: 110px;*/
    /*height: 28px;*/
    /*background: #000000ad;*/
    /*border-radius: 5px;*/
    /*color: #fff;*/
    /*text-align: center;*/
    /*vertical-align: middle;*/
    /*font-size: 16px;*/
    /*padding-top: 7px;*/
    /*top: -30px;*/
    /*left: 38%;*/
    /*z-index: 9999999;*/
/*}*/
.item.active {
border: 1px solid #4CAF50;

}
.constructor_position.tri{
    /*clip-path: polygon(0 10%, 100% 0, 100% 100%, 0 90%);*/
    /*-webkit-clip-path: polygon(0 10%, 100% 0, 100% 100%, 0 90%);*/
    /*border-radius: unset!important;*/
}

.constructor_position.tri_top{
    z-index: 9999;
    /*clip-path: polygon(0 10%, 100% 0, 100% 100%, 0 90%);*/
    /*-webkit-clip-path: polygon(0 10%, 100% 0, 100% 100%, 0 90%);*/
    /*border-radius: unset!important;*/
    /*border: unset;*/
}
.tri_top_block, .tri_bottom_block, .tri_center_block {
    width: 100%;
    height: 16%;
    border: 1px solid black;
    box-sizing: border-box;
    position: absolute;
    overflow: hidden;
}
.tri_top_block {
    border-bottom: 0;
    border-radius: 100% 0 0 0;
    top: 0;
}
.tri_top_block:before, .tri_bottom_block:before {
    content: "";
    display: block;
    width: 100%;
    height: 5px;
    background-color: white;
    position: absolute;
    bottom: -1px;
}
.tri_bottom_block:before {
    bottom: unset;
    top: -1px;
}
.tri_top_block.tri_top_block_right {
    border-radius: 0 100% 0 0;
}
.tri_center_block {
    border-top: 0;
    border-bottom: 0;
    border-radius: 0 0 0 0;
    height: 68%;
    top: 16%;
}
.tri_bottom_block {
    border-top: 0;
    border-radius: 0 0 0 100%;
    bottom: 0;
}
.tri_bottom_block.tri_bottom_block_right {
    border-radius: 0 0 100% 0;
}
.tri_top_block_work_area {
    position: absolute;
    width: 100%;
    height: 625%;
}
.tri_bottom_block_work_area {
    position: absolute;
    width: 100%;
    height: 625%;
    bottom: 0;
}
.tri_center_block_work_area {
    position: absolute;
    width: 100%;
    height: 147.05882353%;
    bottom: 0;
    top: -23.5294117647%;
}
.tri_block {
    position: absolute;
    top: 1px;
    bottom: 1px;
    right: 1px;
    left: 1px;
    box-sizing: border-box;
}
.tri_block .tri_top_block, .tri_block  .tri_bottom_block, .tri_block .tri_center_block {
    border: unset;
}
.info_button, .delete_button {
    display: block;
    cursor: pointer;
    position: absolute;
    top: -23px;
    width: 17px;
    height: 17px;
    border-radius: 99px;
    border: 1px solid #4CAF50;
    background-color: #FFFFFF;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99999999;
}
.info_button {
    background-image: url("./images/green_i.png");
    background-position: 49%;
    background-repeat: no-repeat;
    background-size: 15%;
}
.delete_button {
    background-image: url(./images/green_trash.png);
    background-position: 4px center;
    background-repeat: no-repeat;
    background-size: 10px;
}
.info_button.bottom, .delete_button.bottom {
    top: unset;
    bottom: -23px;
}
.info_button.left, .delete_button.left {
    top: 50%;
    transform: translateY(-50%);
    left: -26px;
}
.info_button.right, .delete_button.right {
    top: 50%;
    left: unset;
    transform: translateY(-50%);
    right: -26px;
}
.info_button.top, .info_button.bottom {
    margin-left: -15px;
}
.delete_button.top, .delete_button.bottom {
    margin-left: 15px;
}
.info_button.left, .info_button.right {
    margin-top: -15px;
}
.delete_button.left, .delete_button.right {
    margin-top: 15px;
}
</style>
<script>
    import { createEventDispatcher } from 'svelte';
    import { mutations, responsiveClass, goodsList, minimalWidthItem, selectedPlusItem, isDrag, draggedItem,
        hiddenGoodsList, selectedItem, tabImagesArray, combinedArray, onClickOutsideCheck} from '../../mainStore.js';
    import helper from '../../helper.js';
    import ClickOutside from 'svelte-click-outside';
    const dispatch = createEventDispatcher();
    export let width
    export let height
    export let left
    export let right
    export let top
    export let bottom
    export let radiusTopLeft = 0
    export let radiusBottomLeft = 0
    export let radiusTopRight = 0
    export let radiusBottomRight = 0
    export let positionName
    export let horizontal = true
    export let tri = false
    export let haveTopSide = true
    export let orientation = 'top'
    export let widthInMm
    export let touchX = 0
    export let touchY = 0
    export let offset = 0
    export let readOnly = false

    $: if (readOnly) {
        mutations.setSelectedItem(null)
    }

    let dragoverElement
    let dragImage = document.createElement("img");
    let hoverPlus = null
    dragImage.setAttribute('src', './build/images/onePx.png')
    let plusList =[]
    let exceptionList = []
    $: dragoverElementRect = dragoverElement && dragoverElement.getBoundingClientRect()
    $: isRadius = !!((radiusTopLeft > 5) + (radiusBottomLeft > 5) + (radiusTopRight > 5) + (radiusBottomRight > 5))

    function getStyle(hidden = false) {
        if (hidden) {
            return 'width:' + width + '%;' +
                'height:' + height + '%;' +
                ((typeof left !== 'undefined') ? 'left:' + left + '%;':'') +
                ((typeof right !== 'undefined') ? 'right:' + right + '%;':'') +
                ((typeof top !== 'undefined') ? 'top:' + top + '%;':'') +
                ((typeof bottom !== 'undefined') ? 'bottom:' + bottom + '%;':'') +
                'border-radius:' +  radiusTopLeft + 'px ' + radiusTopRight + 'px ' + radiusBottomRight + 'px ' + radiusBottomLeft + 'px;' +
                'border: unset;'
        } else {
            return 'width:' + width + '%;' +
                'height:' + height + '%;' +
                ((typeof left !== 'undefined') ? 'left:' + left + '%;':'') +
                ((typeof right !== 'undefined') ? 'right:' + right + '%;':'') +
                ((typeof top !== 'undefined') ? 'top:' + top + '%;':'') +
                ((typeof bottom !== 'undefined') ? 'bottom:' + bottom + '%;':'') +
                'border-radius:' +  radiusTopLeft + 'px ' + radiusTopRight + 'px ' + radiusBottomRight + 'px ' + radiusBottomLeft + 'px;' +
                (isRadius ? "overflow: inherit" : '')
        }
    }

    function clickPlus(plusItem, onTop = false) {
        plusItem.onTop = onTop
        mutations.setSelectedPlusItem(plusItem)
        mutations.setMainTabIndex(0)
        mutations.setShowModal(true)
        mutations.setModalTitle("Внутренняя оснастка")
        mutations.setModalType("items")
        if (onTop) {
            mutations.setTabName("top")
            mutations.setModalState("top")
        } else {
            mutations.setTabName("bottom")
            mutations.setModalState("bottom")
        }
    }

    function getWidthStyle(plusItem) {

        if (typeof plusItem.x1 !== 'undefined') {
            let x = (plusItem.x1/widthInMm*100)
            if (x > 100) {
                x = 100
            }
            let width = ((plusItem.x2-plusItem.x1)/widthInMm*100)
            if (x + width > 100) {
                width = 100 - x
            }
            if(horizontal){
                return 'left:'+ x + '%; width:' + width + '%;'
            }
            return 'top:'+ x + '%; width:100%; height:' + width + '%;'
        } else {
            let x = (plusItem.x/widthInMm*100)
            if (x > 100) {
                x = 100
            }
            let width = (plusItem.width/widthInMm*100)
            if(horizontal){
                return 'left:'+ x + '%; width:' + width + '%;'
            }
            return 'top:'+ x + '%; width:100%; height:' + width + '%;'
        }
    }

    function refreshPlusList() {
        let list = $goodsList
        let result = []
        let exceptionPlaceListTemp = []

        let arr = list.filter(el => el.position == positionName)

        arr = arr.sort(function(a, b) {
            return a.x - b.x;
        });
        let x = 0
        let xTop = 0
        for (let item of arr) {
            if (item.onTop || item.is_big) {
                if(item.x >= xTop) {
                   let currentXTop = item.x - xTop

                   if($minimalWidthItem <= currentXTop) {
                       result.push({
                           x: xTop,
                           width: currentXTop,
                           position: positionName,
                           onTop: true
                       })
                   }
                }
                xTop = item.x + item.width
            }
            if(!item.onTop || item.is_big) {
                if(item.x >= x){
                   let currentX = item.x - x

                   if($minimalWidthItem <= currentX) {
                       result.push({
                           x: x,
                           width: currentX,
                           position: positionName,
                           onTop: false
                       })
                   }
                }
                x = item.x + item.width
            }

            if (!$draggedItem || $draggedItem !== item) {
                if ($selectedItem) {
                    if (item.onTop == $selectedItem.onTop || item.is_big || $selectedItem.is_big){
                        let curX = x
                        if (item.onTop) {
                            curX = xTop
                        }
                        exceptionPlaceListTemp.push({x1: item.x, x2: curX})
                    }
                } else {
                    if (item.is_big){
                        let curX = x
                        if (item.onTop) {
                            curX = xTop
                        }
                        exceptionPlaceListTemp.push({x1: item.x, x2: curX})
                    }
                }

            }
        }

        if ($draggedItem) {
            let exceptions = $draggedItem["exception_place_" + helper.ucFirst(positionName) + "_" + $draggedItem.tabName]
            exceptionPlaceListTemp = [...exceptionPlaceListTemp, ...exceptions]
        }
        exceptionList = exceptionPlaceListTemp
        try{
            if($minimalWidthItem <= (widthInMm - xTop)){
                result.push({
                    x: xTop,
                    width: (widthInMm - xTop),
                    position: positionName,
                    onTop: true
                })
            }
            if($minimalWidthItem <= (widthInMm - x)){
                result.push({
                    x: x,
                    width: (widthInMm - x),
                    position: positionName,
                    onTop: false
                })
            }
        }catch(e){
            console.log(e)
        }

        plusList = result
    }

    function dragStart(event,item) {
        if (readOnly) {
            return
        }
        event.dataTransfer.setDragImage(dragImage, 10, 10);
        let bort
        if (horizontal) {
            bort = event.target.clientWidth
            offset = event.offsetX
        } else {
            offset = event.offsetY
            bort = event.target.clientHeight
        }

        offset = item.width / bort * offset
        start(item)
        selectItem(item)
    }

    function touchStart(event,item) {
        if (readOnly) {
            return
        }
        event.preventDefault()
        let bort
        if (horizontal) {
            bort = event.target.clientWidth
            offset = event.touches[0].clientX - event.target.getBoundingClientRect().left
        } else {
            bort = event.target.clientHeight
            offset = event.touches[0].clientY - event.target.getBoundingClientRect().top
        }
        offset = item.width / bort * offset
        start(item)
        selectItem(item)
    }

    function start(item) {
        if (readOnly) {
            return
        }
        mutations.setDraggedItem(item)
        setTimeout(()=>{
            mutations.setIsDrag(true)
        }, 8)
    }

    function dragEnter(event){
        if (readOnly) {
            return
        }
        let e = {}
        if (!horizontal) {
            e.x = event.offsetY==undefined?event.layerY:event.offsetY;
            e.width = event.target.clientHeight
        } else {
            e.x = event.offsetX==undefined?event.layerX:event.offsetX;
            e.width = event.target.clientWidth
        }

        e.widthInMm = widthInMm
        e.draggedItem = $draggedItem
        e.positionName = positionName
        e.exceptionPlaceList = exceptionList

        dispatch('itemMove', {
            eventItem: e
        });
    }

    function touchObserver(x, y) {
        if (readOnly) {
            return
        }
        if (dragoverElementRect) {
        // alert(dragoverElementRect.top)
            if(x >= dragoverElementRect.left && x <= dragoverElementRect.right && y >= dragoverElementRect.top && y <= dragoverElementRect.bottom) {
                let e = {}
                if (!horizontal) {
                    e.x = y -  dragoverElementRect.top
                    e.width = dragoverElementRect.height
                } else {
                    e.x = x - dragoverElementRect.left
                    e.width = dragoverElementRect.width
                }

                e.widthInMm = widthInMm
                e.draggedItem = $draggedItem
                e.positionName = positionName
                e.exceptionPlaceList = exceptionList
                if (!$isDrag) {
                    start($selectedItem)
                }
                dispatch('itemMove', {
                    eventItem: e
                });

            }
        }
    }

    function checkPlusActive(plusItem, selected, hoverPlus) {
        if (selected) {
            if (plusItem.x == selected.x && plusItem.width == selected.width && plusItem.position == selected.position && plusItem.onTop == selected.onTop) {
                return true
            }
        }
        if(hoverPlus) {
            if (plusItem.x == hoverPlus.x && plusItem.width == hoverPlus.width && plusItem.position == hoverPlus.position && plusItem.onTop == hoverPlus.onTop) {
                return true
            }
        }
        return false
    }

    function selectItem(item) {
        if (readOnly) {
            return
        }
        mutations.setOnClickOutsideCheck(true)
        mutations.setSelectedItem(item)
        setTimeout(()=>{
            mutations.setOnClickOutsideCheck(false)
        }, 8)
    }

    function getItemImage(item) {
        return 'background-image:url("'+getImage(item)+'");     ' +
         'background-position: center;\n'+
         'background-repeat: no-repeat;\n'
    }

    function getImage(item) {
        if(item.icon_image){
            return item.icon_image
        } else {
            if(item.category.image) {
                return item.category.image
            }
            return getDummy()
        }
    }

    function getDummy() {
        return ""
    }

    function onClickOutside() {
        if (readOnly) {
            return
        }
        if ($onClickOutsideCheck == true) {
            return
        }
        mutations.setOnClickOutsideCheck(true)
        mutations.setSelectedItem(null);
        setTimeout(()=>{mutations.setOnClickOutsideCheck(false)}, 8)
    }

    $: touchObserver(touchX, touchY)
    $: refreshPlusList($hiddenGoodsList)

    function plusEnter(item) {
        if (readOnly) {
            return
        }
        hoverPlus = item
    }

    function plusLeave(item) {
        if (readOnly) {
            return
        }
        hoverPlus = null
    }

    function openInfo(item) {
        if (readOnly) {
            return
        }
        mutations.setShowModal(true)
        mutations.setModalTitle(item.name)
        mutations.setModalType("oneItem")
        mutations.setModalState(item)
    }

    function deleteItem(item) {
        if (readOnly) {
            return
        }
        mutations.setModalState({
            modalType: null,
            modalState: null,
            modalTitle: "",
            showModal: false,
            item: item,
        })
        mutations.setModalType("confirmation")
        mutations.setShowModal(true)
        mutations.setModalTitle("")
    }

</script>

{#if (!tri)}
<div class="constructor_position {$responsiveClass} {tri? 'tri':''}" style="{getStyle()}">


    {#if ($isDrag && $selectedItem && !$selectedItem.onTop)}
        <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>

        {#each exceptionList as item}
            <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
        {/each}
    {/if}

    {#if (!readOnly && !$isDrag && !tri)}
        {#each plusList as plusItem}
            {#if (!plusItem.onTop)}
                <div class="plus {checkPlusActive(plusItem, $selectedPlusItem)? 'active' : ''} {!isRadius? 'plus_hint':''}" style="{getWidthStyle(plusItem)}">
                    <div on:click="{(event) => clickPlus(plusItem, false)}" class="plus_click"></div>
                </div>
            {/if}
        {/each}
    {/if}
    {#each $goodsList as item}
        {#if (item.position == positionName && !item.onTop)}
            <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}">
                {#if (!$isDrag && $selectedItem==item)}
                    <div class="info_button {orientation == 'top' ? 'bottom' : orientation == 'bottom' ? 'top' : orientation == 'left' ? 'right' : 'left' }" on:click={() => openInfo(item)}></div>
                    <div class="delete_button {orientation == 'top' ? 'bottom' : orientation == 'bottom' ? 'top' : orientation == 'left' ? 'right' : 'left' }" on:click={() => deleteItem(item)}></div>
                {/if}
            </div>
        {/if}
    {/each}



    {#each $hiddenGoodsList as item}
        {#if (item.position == positionName && !item.onTop)}
            <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                    on:touchstart="{(event) => touchStart(event, item)}"
                    on:click="{(event) => selectItem(item)}"
                    on:dragstart="{(event) => dragStart(event, item)}"></div>
            </ClickOutside>
        {/if}
    {/each}
    {#if (haveTopSide)}
        <div class="constructor_top_side" style="{orientation}: -80%;">
            {#if ($isDrag && $selectedItem && $selectedItem.onTop)}
                <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>
                {#each exceptionList as item}
                    <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
                {/each}
            {/if}
            {#if (!readOnly && !$isDrag)}
                {#each plusList as plusItem}
                    {#if (plusItem.onTop)}
                        <div class="plus {checkPlusActive(plusItem, $selectedPlusItem)? 'active' : ''} {!isRadius? 'top_plus_hint':''}" style="{getWidthStyle(plusItem)}">
                            <div on:click="{(event) => clickPlus(plusItem, true)}" class="plus_click"></div>
                        </div>
                    {/if}
                {/each}
            {/if}
            {#each $goodsList as item}
                {#if (item.position == positionName && item.onTop)}
                    <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}">
                        {#if (!$isDrag && $selectedItem==item)}
                            <div class="info_button {orientation == 'top' ? 'top' : orientation == 'bottom' ? 'bottom' : orientation == 'left' ? 'left' : 'right' }" on:click={() => openInfo(item)}></div>
                            <div class="delete_button {orientation == 'top' ? 'top' : orientation == 'bottom' ? 'bottom' : orientation == 'left' ? 'left' : 'right' }" on:click={() => deleteItem(item)}></div>
                        {/if}
                    </div>
                {/if}
            {/each}
            {#each $hiddenGoodsList as item}
                {#if (item.position == positionName && item.onTop)}
                    <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                        <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                            on:touchstart="{(event) => touchStart(event, item)}"
                            on:click="{(event) => selectItem(item)}"
                            on:dragstart="{(event) => dragStart(event, item)}"></div>
                    </ClickOutside>
                {/if}
            {/each}
        </div>
    {/if}


</div>
{/if}
{#if (tri)}
<div class="constructor_position {$responsiveClass} {tri? 'tri_top':''}" style="{getStyle()}z-index:unset;">
    <div class="tri_top_block {orientation == 'right' ? 'tri_top_block_right' : ''}">

    </div>
    <div class="tri_center_block">

    </div>
    <div class="tri_bottom_block {orientation == 'right' ? 'tri_bottom_block_right' : ''}">

    </div>
    <div class="tri_block">
        {#if ($isDrag && $selectedItem && !$selectedItem.onTop)}
            <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>

            {#each exceptionList as item}
                <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
            {/each}
        {/if}

        {#if (!readOnly && !$isDrag && tri)}
            {#each plusList as plusItem}
                {#if (!plusItem.onTop)}
                    <div class="plus {checkPlusActive(plusItem, $selectedPlusItem)? 'active' : ''} {!isRadius? 'plus_hint':''}" style="{getWidthStyle(plusItem)}">
                        <div on:click="{(event) => clickPlus(plusItem, false)}" class="plus_click"></div>
                    </div>
                {/if}
            {/each}
        {/if}
        {#each $goodsList as item}
            {#if (item.position == positionName && !item.onTop)}
                <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}">
                    {#if (!$isDrag && $selectedItem==item)}
                        <div class="info_button {orientation == 'top' ? 'bottom' : orientation == 'bottom' ? 'top' : orientation == 'left' ? 'right' : 'left' }" on:click={() => openInfo(item)}></div>
                        <div class="delete_button {orientation == 'top' ? 'bottom' : orientation == 'bottom' ? 'top' : orientation == 'left' ? 'right' : 'left' }" on:click={() => deleteItem(item)}></div>
                    {/if}
                </div>
            {/if}
        {/each}



        {#each $hiddenGoodsList as item}
            {#if (item.position == positionName && !item.onTop)}
                <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                    <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                        on:touchstart="{(event) => touchStart(event, item)}"
                        on:click="{(event) => selectItem(item)}"
                        on:dragstart="{(event) => dragStart(event, item)}"></div>
                </ClickOutside>
            {/if}
        {/each}
        {#if (haveTopSide)}
            <div class="constructor_top_side" style="{orientation}: -80%;">
                {#if ($isDrag && $selectedItem && $selectedItem.onTop)}
                    <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>
                    {#each exceptionList as item}
                        <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
                    {/each}
                {/if}
                {#if (!readOnly && !$isDrag)}
                    {#each plusList as plusItem}
                        {#if (plusItem.onTop)}
                            <div class="plus {checkPlusActive(plusItem, $selectedPlusItem)? 'active' : ''} {!isRadius? 'top_plus_hint':''}" style="{getWidthStyle(plusItem)}">
                                <div on:click="{(event) => clickPlus(plusItem, true)}" class="plus_click"></div>
                            </div>
                        {/if}
                    {/each}
                {/if}
                {#each $goodsList as item}
                    {#if (item.position == positionName && item.onTop)}
                        <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}">
                            {#if (!$isDrag && $selectedItem==item)}
                                <div class="info_button {orientation == 'top' ? 'top' : orientation == 'bottom' ? 'bottom' : orientation == 'left' ? 'left' : 'right' }" on:click={() => openInfo(item)}></div>
                                <div class="delete_button {orientation == 'top' ? 'top' : orientation == 'bottom' ? 'bottom' : orientation == 'left' ? 'left' : 'right' }" on:click={() => deleteItem(item)}></div>
                            {/if}
                        </div>
                    {/if}
                {/each}
                {#each $hiddenGoodsList as item}
                    {#if (item.position == positionName && item.onTop)}
                        <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                            <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                                on:touchstart="{(event) => touchStart(event, item)}"
                                on:click="{(event) => selectItem(item)}"
                                on:dragstart="{(event) => dragStart(event, item)}"></div>
                        </ClickOutside>
                    {/if}
                {/each}
            </div>
        {/if}
        <!--<div class="tri_top_block {orientation == 'right' ? 'tri_top_block_right' : ''}">
            <div class="tri_top_block_work_area">
                {#if (!$isDrag)}
                    {#each plusList as plusItem}
                        {#if (!plusItem.onTop)}
                            <div class="plus {checkPlusActive(plusItem, $selectedPlusItem, hoverPlus)? 'active' : ''}" on:mouseenter="{()=> plusEnter(plusItem)}" on:mouseleave="{()=> plusLeave(plusItem)}" style="{getWidthStyle(plusItem)}">
                                <div on:click="{(event) => clickPlus(plusItem, false)}" class="plus_click"></div>
                            </div>
                        {/if}
                    {/each}
                {/if}

                {#each $goodsList as item}
                    {#if (item.position == positionName)}
                        <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}"></div>
                    {/if}
                {/each}

                {#each $hiddenGoodsList as item}
                    {#if (item.position == positionName)}
                        <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                            <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                                on:touchstart="{(event) => touchStart(event, item)}"
                                on:click="{(event) => selectItem(item)}"
                                on:dragstart="{(event) => dragStart(event, item)}"></div>
                        </ClickOutside>
                    {/if}
                {/each}

                {#if ($isDrag && $selectedItem && !$selectedItem.onTop)}
                    <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>

                    {#each exceptionList as item}
                        <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
                    {/each}
                {/if}
            </div>
        </div>
        <div class="tri_center_block">
            <div class="tri_center_block_work_area">
                {#if (!readOnly && !$isDrag)}
                    {#each plusList as plusItem}
                        {#if (!plusItem.onTop)}
                            <div class="plus {checkPlusActive(plusItem, $selectedPlusItem, hoverPlus)? 'active' : ''}" on:mouseenter="{()=> plusEnter(plusItem)}" on:mouseleave="{()=> plusLeave(plusItem)}" style="{getWidthStyle(plusItem)}">
                                <div on:click="{(event) => clickPlus(plusItem, false)}" class="plus_click"></div>
                            </div>
                        {/if}
                    {/each}
                {/if}

                {#each $goodsList as item}
                    {#if (item.position == positionName)}
                        <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}"></div>
                    {/if}
                {/each}

                {#each $hiddenGoodsList as item}
                    {#if (item.position == positionName)}
                        <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                            <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                                on:touchstart="{(event) => touchStart(event, item)}"
                                on:click="{(event) => selectItem(item)}"
                                on:dragstart="{(event) => dragStart(event, item)}"></div>
                        </ClickOutside>
                    {/if}
                {/each}

                {#if ($isDrag && $selectedItem && !$selectedItem.onTop)}
                    <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>

                    {#each exceptionList as item}
                        <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
                    {/each}
                {/if}
            </div>
        </div>
        <div class="tri_bottom_block {orientation == 'right' ? 'tri_bottom_block_right' : ''}">
            <div class="tri_bottom_block_work_area">
                {#if (!readOnly && !$isDrag)}
                    {#each plusList as plusItem}
                        {#if (!plusItem.onTop)}
                            <div class="plus {checkPlusActive(plusItem, $selectedPlusItem, hoverPlus)? 'active' : ''}" on:mouseenter="{()=> plusEnter(plusItem)}" on:mouseleave="{()=> plusLeave(plusItem)}" style="{getWidthStyle(plusItem)}">
                                <div on:click="{(event) => clickPlus(plusItem, false)}" class="plus_click"></div>
                            </div>
                        {/if}
                    {/each}
                {/if}

                {#each $goodsList as item}
                    {#if (item.position == positionName)}
                        <div class="item {$selectedItem==item ? 'active' : ''}" style="{getWidthStyle(item)}{getItemImage(item)}"></div>
                    {/if}
                {/each}

                {#each $hiddenGoodsList as item}
                    {#if (item.position == positionName)}
                        <ClickOutside on:clickoutside={() => {onClickOutside()}}>
                            <div class="item_hidden"  style="{getWidthStyle(item)}" draggable="true"
                                on:touchstart="{(event) => touchStart(event, item)}"
                                on:click="{(event) => selectItem(item)}"
                                on:dragstart="{(event) => dragStart(event, item)}"></div>
                        </ClickOutside>
                    {/if}
                {/each}

                {#if ($isDrag && $selectedItem && !$selectedItem.onTop)}
                    <div class="dragover" on:dragover="{(event) => dragEnter(event)}" bind:this={dragoverElement}></div>

                    {#each exceptionList as item}
                        <div class="exceptionElement" style="{getWidthStyle(item)}"></div>
                    {/each}
                {/if}
            </div>
        </div>-->
    </div>

</div>
{/if}
